<template>
    <div>
        <BOverlay :show="is_load" rounded="sm">
            <div class="app_vue_list" >
                
                <!-- filter -->
                <div class="filter_block mb-3">
                    <users_filter
                        v-model:filter="filter"
                        @search_called="handleSearch"
                        @clean_filter="handleCleanFilters"
                    />
                </div>
                
                <BTable
                    class="cursor-pointer"
                    @row-clicked="viewUser"  :thead-class="head_class" :tbody-tr-class="rowClass"  responsive :items="rows" :fields="table_fields">
                    <!-- HEAD FIELDS -->
                    <template v-slot:head(id)="data">
                        <grid :list_ordering="'id'" field_name="ID" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(contact_name)="data">
                        <grid :list_ordering="'contact_name'" field_name="Користувач" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(email)="data">
                        <grid :list_ordering="'email'" field_name="E-mail" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(company)="data">
                        <grid :list_ordering="'company'" field_name="Контрагент" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(edrpou)="data">
                        <grid :list_ordering="'edrpou'" field_name="ЄДРПОУ" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(contact_tel)="data">
                        <grid :list_ordering="'contact_tel'" field_name="Телефон" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(registerDate)="data">
                        <grid :list_ordering="'registerDate'" field_name="Дата реєстрації" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(text_status)="data">
                        <grid :list_ordering="'text_status'" field_name="Статус" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(files_count)="data">
                        <grid :list_ordering="'files_count'" field_name="Файлів" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(subscription_deactivated)="data">
                        <grid :list_ordering="'subscription_deactivated'" field_name="Відключена розсилка" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <!-- ROW FIELDS -->
                    <template v-slot:cell(registerDate)="data">
                        {{fmtDate(data.item.registerDate)}}
                    </template>
                    
                </BTable>
            </div>
            
            <div class="pt-4" v-if="rows.length > 0">
                <pagination
                    key="down"
                    :total="pagination.total"
                    :limit="pagination.limit"
                    :current="pagination.pagesCurrent"
                    @page-change="handlePageChange">
                </pagination>
            </div>
        </BOverlay>
    </div>
</template>

<script>

import {
    BButton,
    BTable,
    BOverlay,
    BTooltip,
} from 'bootstrap-vue-next';

import grid from "../../../shared/list/grid/grid.vue";
import pagination from "../../../shared/list/pagination/pagination.vue";
import List_filter from "../../../shared/list/filter/list_filter.vue";
import Users_filter from "./filter/users_filter.vue";

export default {
    name: "users_table",
    
    props : {
    
    },
 
    
    components : {
        Users_filter,
        List_filter,
        BTable,
        BOverlay,
        BButton,
        BTooltip,
        grid,
        pagination
    },
    
    data() {
        return {
            rows : [],
            is_load : true,
            
            list: {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30
            },
            
            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1
            },
            
            filter: {
                search: "",
                user_status: "",
                company_edrpou: "",
            },
            
            fields : [
                {key : 'id',label: 'u.id ', class:'align-middle'},
                {key : 'contact_name',label: 'tu.contact_name', class:'align-middle'},
                {key : 'company',label: 'tu.company ', class:'align-middle'},
                {key : 'edrpou',label: 'tu.edrpou ', class:'align-middle'},
                {key : 'contact_tel',label: 'tu.contact_tel', class:'align-middle',},
                {key : 'files_count',label: 'files.num_files', class:'align-middle text-right'},
                {key : 'text_status',label: 'filter_status ', class:'align-middle'},
                {key : 'email',label: 'u.email', class:'align-middle'},
                {key : 'registerDate',label: 'u.registerDate', class:'align-middle'},
            ],
        }
    },
    
    mounted() {
        this.load_items();
    },
    
    created() {
    
    },
    
    methods : {
        
        handleOrdering({ordering, direction}) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.load_items();
        },
        
        handlePageChange({page, start}) {
            this.list.start = start;
            this.load_items();
        },
        
        handleSearch(search_str) {
            this.filter.search = search_str;
            this.list.start = 0;
            this.load_items();
        },
        
        handleCleanFilters() {
            this.filter = {
                search: "",
                user_status: "",
                company_edrpou: "",
            };
            
            this.list = {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30
            };
            
            this.load_items();
        },
        
        viewUser(item) {
            window.location = '/kontrahenty/' + item.id;
        },
        
        filter_select(res) {
            this.filter[res.type] = res.value;
            this.list.start = 0;
            this.load_items();
        },
        
        async load_items() {
            this.is_load = true;
            this.rows = [];
            
            await api.post('/tenders/sales/tenders/contragents',{
                filter  : this.filter,
                list    : this.list
            }).then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.rows = data.data;
                    
                    if (data.message?.pagination) {
                        this.pagination = data.message.pagination;
                    }
                }
            }).catch(e => {
                this.is_load = false;
                this.rows = [];
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        rowClass(item) {
            if (!item) return;
            let itemClass = '';
            
            if (item.subscription_deactivated) {
                itemClass = 'bg-danger-100';
            }
            
            switch (item.text_status) {
                case "Не завершена реєстрація":
                    itemClass = 'app_archive';
                    break;
                case "Новий":
                    itemClass = 'app_sended';
                    break;
                case "Видалений":
                    itemClass = 'app_archive';
                    break;
                case "Чорний список":
                    itemClass = 'app_reject';
                    break;
                
                
            }
            
            return itemClass;
        }
    },
    
    computed : {
        
        head_class() {
        },
        
        table_fields() {
            return this.fields;
        }
    }
    
}
</script>


<style scoped>

</style>